import {
    SCHEDULE_GET_REQUEST,
    SCHEDULE_GET_RECEIVE
} from "../config/actions";
import config from '../config/config';
import axios from 'axios';

export function getSchedule() {
    return dispatch => {
        dispatch({
            type: SCHEDULE_GET_REQUEST
        });
        axios(config.server.endpoint + 'backend/schedule', {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                dispatch({
                    type: SCHEDULE_GET_RECEIVE,
                    data: response.data
                });
            }
        })
    }
}